// Enregistrement du service worker PWA. Volontairement minimal : pas de
// bibliothèque (workbox / vite-plugin-pwa) pour ne rien ajouter aux
// dépendances npm — juste l'API standard du navigateur. N'échoue jamais
// silencieusement de façon bloquante : si le navigateur ne supporte pas les
// service workers (ou en dev), on ne fait simplement rien.
export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  if (import.meta.env.DEV) return; // pas de cache pendant le dev (vite HMR)

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('Service worker non enregistré :', err);
    });
  });
}
